import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../../shared/my-constants';
@Injectable()
export class BedTransferService {
  private headers = new Headers({'Content-Type': 'application/json'});
  private Addrevisit = webapi + 'trn_admission/autocomplete/';
  private AddRecord = webapi + 'trn_transfer_bed/create';
  private autochargebedallication = webapi + 'mbillipdbillcharges/autochargeforallocation/';
  private autochargebedrelease = webapi + 'mbillipdbillcharges/autochargeforrelease/';

  constructor(private http: Http) {
  }

  addservice(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  autochargeinsert(admissionid: any, bedid: any) {
    console.log(this.autochargebedallication + admissionid + '/' + bedid);
    return this.http.get(this.autochargebedallication + admissionid + '/' + bedid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  autochargereales(admissionid: any, bedid: any) {
    return this.http.get(this.autochargebedrelease + admissionid + '/' + bedid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/bed-management/bed-transfer/bed-transfer.service.ts